/** Normaliza `_id` vindo da legacy-api (string, ObjectId ou Extended JSON). */
export function parseLegacyId(value: unknown): string {
  if (value == null || value === '') return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'object' && value !== null) {
    const record = value as Record<string, unknown>;
    if (typeof record.$oid === 'string') return record.$oid;
    if (typeof record.toString === 'function') {
      const str = record.toString();
      if (str && str !== '[object Object]') return str;
    }
  }
  return String(value);
}
